import { AfterViewInit, Component, Inject, Input, OnChanges, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FourDService, Dataset, EPSGCodes } from "4d-mapper";

import { XsEventListenerInterface } from "@src/app/xs/interfaces/event-listener.interface";
import { XsIdentityInterface } from "@src/app/xs/interfaces/identify.interface";
import { XsApplicationEventsService } from "@src/app/xs/services/events/application-events.service";
import { CesiumMapService } from "@src/app/service/map-viewer.service";

const Cesium = window['Cesium']
@Component({
    selector:'align-bounds',
    templateUrl:'./align-bounds.component.html'
})
export class AlignBoundsComponent implements OnChanges, AfterViewInit  {

    __ID = null;
    __EVENTS = null;

    @Input()
    dataset:Dataset = null;

    viewer:any = null;

    plotted:any
    loading:boolean = true;

    constructor( private fourd:FourDService, public applicationEvents: XsApplicationEventsService, public cesiumMapService: CesiumMapService ){
        this.__ID = XsIdentityInterface.__init(this);
        this.__EVENTS = XsEventListenerInterface.__init(this);
        console.log('## construct');
    }

    // ___mapViewer ( incoming:any = null ) {
    //     this.viewer = incoming.viewer;
    // }

    ngOnChanges() { 
        // console.log('## changes', this.dataset);
    }

    ngAfterViewInit(){

        // console.log('## init');
        this.viewer = this.cesiumMapService.getMap('align').viewer;

        if(!this.dataset.initParams)
            this.dataset.initParams = {}
        if(this.dataset.crs)
            this.changed()
            
        
    }

    plot(d:any){
        // console.log('## plot',d);
        if(this.plotted)
            this.viewer.entities.remove(this.plotted)

        var train = []
        

        if(d instanceof Dataset){
            train = [
                d['llng'], d['llat'],
                d['llng'], d['ulat'],
                d['ulng'], d['ulat'],
                d['ulng'], d['llat']
            ]
        }
        else{
            train = [
                d['minX'], d['minY'],
                d['minX'], d['maxY'],
                d['maxX'], d['maxY'],
                d['maxX'], d['minY']
            ]
        }
        this.plotted = this.viewer.entities.add({
            polygon : {
                hierarchy : Cesium.Cartesian3.fromDegreesArray(train),
                material : Cesium.Color.ORANGE.withAlpha(0.5),
                outline : true,
                outlineColor : Cesium.Color.YELLOW
            }
        })

        this.viewer.camera.flyTo({
            destination:Cesium.Rectangle.fromDegrees(train[0],train[1],train[4],train[5])
        })

    }
    changed(){

        // console.log('## changed');

        var e = this.dataset.initParams.easting || 0
        var n = this.dataset.initParams.northing || 0
        var h = this.dataset.initParams.height || 0
        var bbox = this.dataset['unalignedBounds']
        var newBox = {
            minX:e + bbox.minX,
            maxX:e + bbox.maxX,
            minY:n + bbox.minY,
            maxY:n + bbox.maxY,
            minZ:bbox.minZ,
            maxZ:bbox.maxZ
        }
        if(this.dataset.crs && this.dataset.crs.uid){
            this.loading = true
            this.fourd.V.api('/epsg/' + this.dataset.crs.uid,'post',{bounds:newBox}).subscribe(s => {
                this.plot(s)
                this.dataset.initParams.crs_code = this.dataset.crs.uid
                this.loading = false
            },e => {
                this.loading = false
                alert(e.message)
            })
        }
    }

}



@Component({
    selector:'bounds-dialog',
    template:
`<ng-container *ngIf="dataset">
    <div mat-dialog-title>
        {{'FILE_LIST.NAV.ALIGN_BOUNDS' | translate }} - {{ dataset.name}}
    </div>
    <div mat-dialog-content>
        <align-bounds [dataset]="dataset"></align-bounds>
    </div>
    <div mat-dialog-actions style="text-align:right;align-items:inherit!important;justify-content:flex-end!important;">
        <button mat-raised-button (click)="cancel()" >{{ 'GENERIC.CLOSE' | translate }}</button>
        <button mat-raised-button  color="warn" class="float-right ml-2 mr-2" (click)="save()" [disabled]="!dataset.crs">{{ 'GENERIC.NEXT' | translate }} <fa-icon icon="arrow-right"></fa-icon></button>
    </div>
</ng-container>`
})

export class AlignBoundsDialog{

    dataset:Dataset
    
    constructor(public dialogRef: MatDialogRef<AlignBoundsDialog>, @Inject(MAT_DIALOG_DATA) public data: any, private fourD: FourDService) {
    
        if(data.dataset && data.dataset.crs && !data.dataset.crs.uid){
            this.fourD.V.searchByObject(EPSGCodes).equals("id",data.dataset.crs.id).queryObservable().subscribe(s => {
                data.dataset.crs = s.items[0]
                this.dataset = data.dataset
            })
        }
        else{
            this.dataset = data.dataset
        }
    }
    save(){
        this.dataset.saveObservable().subscribe(s => this.dialogRef.close(true))
    }
    cancel(){
        this.dialogRef.close(false)
    }
}